export default "Lav jeres egne flotte stenalderpunge af læder eller stof, og gå på jagt efter bær, nødder eller ”magi”!";